import {CanMatchFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AsDebugAction, DebugService} from "../services/debug.service";

let limit = 10;
let count = 0;
let lastRoute: string | undefined = undefined;
export const redirectLoopProtectionGuard: CanMatchFn = (route, segments) => {
  const url = segments.map(s => s.toString()).join('/');
  const debug = inject(DebugService);
  debug.tryRegister(AsDebugAction({
    name: 'resetRedirectsCheck',
    params: [],
    action: () => {
      count = 0;
    }
  }));

  debug.tryRegister(AsDebugAction({
    name: 'setRedirectsLimit',
    params: ['number'] as const,
    action: (newLimit: number) => {
      limit = newLimit;
    }
  }));

  if (!lastRoute || url === '/error') {
    lastRoute = url;
    return true;
  }

  if (lastRoute !== url) {
    lastRoute = url;
    count = 0;
    return true;
  }

  console.log('redirect loop detected', url, count);
  if (limit <= ++count) {
    console.log('redirect loop limit reached', url, count);
    const router = inject(Router);
    return router.parseUrl('/error');
  }



  return true;
};

